import { graphql } from '@api/generated';
import { getClient } from '@api/client';
import { SearchParams as CustomerSearchParams } from '../components/CustomerSearchBox/CustomerSearchBox';
import { CustomersBySearchResponse } from '@components/CustomerSearch/data/types';

export const getCustomerBySearchQuery = graphql(`
  query getCustomerBySearch($tenantId: ID, $where: CustomerFilterInput) {
    customers(tenantId: $tenantId, where: $where) {
      items {
        id
        name
        contacts {
          id
          type
          value
          memo
          jobRemindersEnabled
          marketingUpdatesEnabled
          invoiceStatementNotification
        }
        type
        locations {
          id
          active
          name
          address {
            street
            unit
            city
            state
            zip
            country
          }
        }
        tenant {
          id
          name
        }
        doNotService
      }
    }
  }
`);

async function searchCustomers(
  searchParams: CustomerSearchParams,
  tenantId?: string,
): Promise<CustomersBySearchResponse> {
  const { data, error, errors } = await getClient().query({
    query: getCustomerBySearchQuery,
    variables: { tenantId, where: searchParams },
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  });

  let failedTenants: string[] = [];

  if (error) {
    throw new Error(error.message);
  }

  if (errors?.length) {
    const failedTenantsInfo = errors.find(
      (error) => error.extensions?.failedTenants,
    );

    if (failedTenantsInfo?.extensions?.failedTenants) {
      failedTenants = failedTenantsInfo.extensions.failedTenants as string[];
    }
  }

  return {
    customers: data.customers?.items || [],
    failedTenants: failedTenants,
  };
}

export default searchCustomers;
